import BaseService from "./BaseService";
import BaseFilter from './BaseFilter';

export class GeneralTermService extends BaseService{
	constructor() {
		super('/GeneralTerm');
	}

	public deleteList(list: number[]) {
		return this.deleteListWithResourceName(list, 'delete-list')
	}

	public consentGeneralTerm(id: number,data: any) {
		return this.updateBase(`${this._resourceName}/consent/${id}`, data);
	}

	public publishGeneralTerm(id: number, data: any) {
		return this.updateBase(`${this._resourceName}/publish/${id}`, data);
	}

	public getOriginalFileById(id: number) {
		return super.getFileByIdWithResourceName(id, 'generalTerm/original-file');
	}

	public getAllByFilter(filter: GeneralTermFilter) {
		return super.getAllByFilterBase(filter);
	}
}

export class GeneralTermFilter extends BaseFilter{
	constructor(name?: string | null ) {
		super();
	
		this._name = name;
	}

	private _name?: string | null;

	public getAllParams(): {} {
		let data = Object.assign({},
			(this._name != null ? { Name: this._name } : {})

		);
		
		return data;
	};
}